// Wrapper fino sobre las Cloud Functions de comparaciones (Postgres/Neon).
import { getFunctions, httpsCallable } from 'firebase/functions';

const functions = getFunctions();
const listarComparacionesFn = httpsCallable(functions, 'listarComparaciones');
const guardarComparacionFn = httpsCallable(functions, 'guardarComparacion');
const eliminarComparacionFn = httpsCallable(functions, 'eliminarComparacion');

export async function listarComparaciones() {
  const result = await listarComparacionesFn();
  return result.data.comparaciones;
}

export async function guardarComparacion(nombre, modelos) {
  const result = await guardarComparacionFn({ nombre, modelos });
  return result.data;
}

export async function eliminarComparacion(id) {
  await eliminarComparacionFn({ id });
}
